import type { Config } from '@ms/yammer-libs-static-config';

type GetConfig = () => Promise<Config>;
export const getConfig: GetConfig = async () => window.__yammerconfig__ as Config;
